import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SupplierDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class SuppliersService {
  constructor(private httpService: HttpService) {}

  public getSuppliers(filterData: object): Observable<SupplierDto> {
    return this.httpService.postHttp<SupplierDto>(
      Constants.ServiceConstants.SUPPLIERS,
      filterData
    );
  }
}
